import { createSlice } from '@reduxjs/toolkit';
import {
  fetchCoachNoByFrameType,
  getAirBrakeTestingHistory,
  getBufferCbcTestingHistory,
  getFibaTestingFlowHistory,
  listTestingAirBrake,
  listTestingBufferCbc,
  listTestingFiba,
  storeTestingAirBrake,
  storeTestingBufferCbc,
  storeTestingFiba,
  updateBufferCbcTestingStatus,
  updateFibaTestingStatus,
  viewTestingAirBrake,
  viewTestingBufferCbc,
  viewTestingFiba,
} from './furnishingTestingThunk';

const initialState = {
  // In initialState
  testingFiba: {
    loading: false,
    success: false,
    error: null,
    data: [],

    pagination: {
      current_page: 1,
      per_page: 10,
      total: 0,
      total_pages: 0,
    },
  },
  fibaTestingSave: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  fibaTestingView: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  fibaTestingHistory: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  fibaTestingStatusUpdate: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  coachNoData: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  testingAirBrake: {
    data: [],
    pagination: {},
    loading: false,
    error: null,
  },
  viewAirBrake: {
    data: null,
    loading: false,
    error: null,
  },
  airBrakeHistory: {
    data: [],
    loading: false,
    error: null,
  },
  testingBufferCbc: {
    data: [],
    pagination: {
      current_page: 1,
      per_page: 10,
      total: 0,
      total_pages: 0,
    },
    loading: false,
    error: null,
  },
  viewBufferCbc: {
    data: null,
    loading: false,
    error: null,
  },
  bufferCbcHistory: {
    data: [],
    loading: false,
    error: null,
  },
  bufferCbcStore: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  bufferCbcStatusUpdate: {
    loading: false,
    success: false,
    error: null,
  },
};
const furnishingtestingSlice = createSlice({
  name: 'furnishingtesting',
  initialState,
  reducers: {  resetBufferCbcStore: (state) => {
      state.bufferCbcStore.loading = false;
      state.bufferCbcStore.success = false;
      state.bufferCbcStore.error = null;
      state.bufferCbcStore.data = null;
    },
    clearBufferCbcError: (state) => {
      state.testingBufferCbc.error = null;
      state.viewBufferCbc.error = null;
      state.bufferCbcHistory.error = null;
      state.bufferCbcStore.error = null;
      state.bufferCbcStatusUpdate.error = null;
    },},
  extraReducers: (builder) => {
    builder

      // Store FIBA Testing
      .addCase(storeTestingFiba.pending, (state) => {
        state.fibaTestingSave.loading = true;
        state.fibaTestingSave.error = null;
      })
      .addCase(storeTestingFiba.fulfilled, (state, action) => {
        state.fibaTestingSave.loading = false;
        state.fibaTestingSave.success = true;
        state.fibaTestingSave.data = action.payload;
      })
      .addCase(storeTestingFiba.rejected, (state, action) => {
        state.fibaTestingSave.loading = false;
        state.fibaTestingSave.error = action.payload || 'Something went wrong';
      })

      // List FIBA Testing
      .addCase(listTestingFiba.pending, (state) => {
        state.testingFiba.loading = true;
        state.testingFiba.error = null;
      })
      .addCase(listTestingFiba.fulfilled, (state, action) => {
        state.testingFiba.loading = false;
        state.testingFiba.success = true;
        state.testingFiba.data = action.payload?.data || [];
        // state.testingFiba.pagination = action.payload?.pagination || null;

        state.testingFiba.pagination = action.payload.data?.pagination || {
          current_page: action.payload.current_page || 1,
          per_page: action.payload.per_page || 10,
          total: action.payload.total || 0,
          total_pages: action.payload.total_pages || 0,
        };
      })
      .addCase(listTestingFiba.rejected, (state, action) => {
        state.testingFiba.loading = false;
        state.testingFiba.error = action.payload || 'Something went wrong';
      })

      // View FIBA Testing
      .addCase(viewTestingFiba.pending, (state) => {
        state.fibaTestingView.loading = true;
        state.fibaTestingView.error = null;
      })
      .addCase(viewTestingFiba.fulfilled, (state, action) => {
        state.fibaTestingView.loading = false;
        state.fibaTestingView.success = true;
        state.fibaTestingView.data = action.payload?.data;
      })
      .addCase(viewTestingFiba.rejected, (state, action) => {
        state.fibaTestingView.loading = false;
        state.fibaTestingView.error = action.payload || 'Something went wrong';
      })

      // FIBA Testing History
      .addCase(getFibaTestingFlowHistory.pending, (state) => {
        state.fibaTestingHistory.loading = true;
        state.fibaTestingHistory.error = null;
      })
      .addCase(getFibaTestingFlowHistory.fulfilled, (state, action) => {
        state.fibaTestingHistory.loading = false;
        state.fibaTestingHistory.success = true;
        state.fibaTestingHistory.data = action.payload?.data?.history || [];
      })
      .addCase(getFibaTestingFlowHistory.rejected, (state, action) => {
        state.fibaTestingHistory.loading = false;
        state.fibaTestingHistory.error = action.payload || 'Something went wrong';
      })
      .addCase(updateFibaTestingStatus.pending, (state) => {
        state.fibaTestingStatusUpdate.loading = true;
        state.fibaTestingStatusUpdate.error = null;
      })
      .addCase(updateFibaTestingStatus.fulfilled, (state, action) => {
        state.fibaTestingStatusUpdate.loading = false;
        state.fibaTestingStatusUpdate.success = true;
        state.fibaTestingStatusUpdate.data = action.payload;
      })
      .addCase(updateFibaTestingStatus.rejected, (state, action) => {
        state.fibaTestingStatusUpdate.loading = false;
        state.fibaTestingStatusUpdate.error = action.payload || 'Something went wrong';
      })
      .addCase(fetchCoachNoByFrameType.pending, (state) => {
        state.coachNoData.loading = true;
        state.coachNoData.error = null;
      })
      .addCase(fetchCoachNoByFrameType.fulfilled, (state, action) => {
        state.coachNoData.loading = false;
        state.coachNoData.success = true;
        state.coachNoData.data = action.payload?.data || [];
      })
      .addCase(fetchCoachNoByFrameType.rejected, (state, action) => {
        state.coachNoData.loading = false;
        state.coachNoData.error = action.payload || 'Something went wrong';
      })
      .addCase(listTestingAirBrake.pending, (state) => {
        state.testingAirBrake.loading = true;
        state.testingAirBrake.error = null;
      })
      .addCase(listTestingAirBrake.fulfilled, (state, action) => {
        state.testingAirBrake.loading = false;
        state.testingAirBrake.data = action.payload.data || [];
        // state.testingAirBrake.pagination = action.payload.pagination || {};
        state.testingAirBrake.pagination = action.payload.pagination || {
          current_page: action.payload.current_page || 1,
          per_page: action.payload.per_page || 10,
          total: action.payload.total || 0,
          total_pages: action.payload.total_pages || 0,
        };
      })
      .addCase(listTestingAirBrake.rejected, (state, action) => {
        state.testingAirBrake.loading = false;
        state.testingAirBrake.error = action.payload;
      })
      .addCase(viewTestingAirBrake.pending, (state) => {
        state.viewAirBrake.loading = true;
        state.viewAirBrake.error = null;
      })
      .addCase(viewTestingAirBrake.fulfilled, (state, action) => {
        state.viewAirBrake.loading = false;
        state.viewAirBrake.data = action.payload.data;
      })
      .addCase(viewTestingAirBrake.rejected, (state, action) => {
        state.viewAirBrake.loading = false;
        state.viewAirBrake.error = action.payload;
      })
      .addCase(storeTestingAirBrake.pending, (state) => {
        state.loading = true;
      })
      .addCase(storeTestingAirBrake.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(storeTestingAirBrake.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getAirBrakeTestingHistory.pending, (state) => {
        state.airBrakeHistory.loading = true;
        state.airBrakeHistory.error = null;
      })
      .addCase(getAirBrakeTestingHistory.fulfilled, (state, action) => {
        state.airBrakeHistory.loading = false;
        state.airBrakeHistory.data = action.payload.data?.history || [];
      })
      .addCase(getAirBrakeTestingHistory.rejected, (state, action) => {
        state.airBrakeHistory.loading = false;
        state.airBrakeHistory.error = action.payload;
      })
      .addCase(listTestingBufferCbc.pending, (state) => {
        state.testingBufferCbc.loading = true;
        state.testingBufferCbc.error = null;
      })
      .addCase(listTestingBufferCbc.fulfilled, (state, action) => {
        state.testingBufferCbc.loading = false;
        state.testingBufferCbc.data = action.payload?.data || [];
        state.testingBufferCbc.pagination = action.payload?.pagination || {
          current_page: action.payload?.current_page || 1,
          per_page: action.payload?.per_page || 10,
          total: action.payload?.total || 0,
          total_pages: action.payload?.total_pages || 0,
        };
      })
      .addCase(listTestingBufferCbc.rejected, (state, action) => {
        state.testingBufferCbc.loading = false;
        state.testingBufferCbc.error = action.payload || 'Something went wrong';
      })

      // View Buffer CBC
      .addCase(viewTestingBufferCbc.pending, (state) => {
        state.viewBufferCbc.loading = true;
        state.viewBufferCbc.error = null;
      })
      .addCase(viewTestingBufferCbc.fulfilled, (state, action) => {
        state.viewBufferCbc.loading = false;
        state.viewBufferCbc.data = action.payload?.data;
      })
      .addCase(viewTestingBufferCbc.rejected, (state, action) => {
        state.viewBufferCbc.loading = false;
        state.viewBufferCbc.error = action.payload || 'Something went wrong';
      })

      // Store Buffer CBC
      .addCase(storeTestingBufferCbc.pending, (state) => {
        state.bufferCbcStore.loading = true;
        state.bufferCbcStore.error = null;
        state.bufferCbcStore.success = false;
      })
      .addCase(storeTestingBufferCbc.fulfilled, (state, action) => {
        state.bufferCbcStore.loading = false;
        state.bufferCbcStore.success = true;
        state.bufferCbcStore.data = action.payload;
      })
      .addCase(storeTestingBufferCbc.rejected, (state, action) => {
        state.bufferCbcStore.loading = false;
        state.bufferCbcStore.error = action.payload || 'Something went wrong';
        state.bufferCbcStore.success = false;
      })

      // Update Buffer CBC Status
      .addCase(updateBufferCbcTestingStatus.pending, (state) => {
        state.bufferCbcStatusUpdate.loading = true;
        state.bufferCbcStatusUpdate.error = null;
        state.bufferCbcStatusUpdate.success = false;
      })
      .addCase(updateBufferCbcTestingStatus.fulfilled, (state, action) => {
        state.bufferCbcStatusUpdate.loading = false;
        state.bufferCbcStatusUpdate.success = true;
        state.bufferCbcStatusUpdate.data = action.payload;
      })
      .addCase(updateBufferCbcTestingStatus.rejected, (state, action) => {
        state.bufferCbcStatusUpdate.loading = false;
        state.bufferCbcStatusUpdate.error = action.payload || 'Something went wrong';
        state.bufferCbcStatusUpdate.success = false;
      })

      // Get Buffer CBC History
      .addCase(getBufferCbcTestingHistory.pending, (state) => {
        state.bufferCbcHistory.loading = true;
        state.bufferCbcHistory.error = null;
      })
      .addCase(getBufferCbcTestingHistory.fulfilled, (state, action) => {
        state.bufferCbcHistory.loading = false;
        state.bufferCbcHistory.data = action.payload?.data?.history || [];
      })
      .addCase(getBufferCbcTestingHistory.rejected, (state, action) => {
        state.bufferCbcHistory.loading = false;
        state.bufferCbcHistory.error = action.payload || 'Something went wrong';
      })
      ;
  },
});
// export const {} = furnishingtestingSlice.actions;
export const { resetBufferCbcStore, clearBufferCbcError } = furnishingtestingSlice.actions;
export default furnishingtestingSlice.reducer;
